import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import createStyles from '@guestyci/foundation/createStyles';
import FlatButton from "../FlatButton";
var useStyles = createStyles({
  root: {
    boxShadow: 'none !important'
  }
}, {
  name: 'Tab'
});

var Tab = function Tab(_ref) {
  var onClick = _ref.onClick,
      tabIndex = _ref.tabIndex,
      value = _ref.value,
      title = _ref.title,
      className = _ref.className,
      disabled = _ref.disabled,
      isActive = _ref.isActive;
  var classes = useStyles();
  var onTabClick = useCallback(function (e) {
    e.stopPropagation();
    onClick(tabIndex, value);
  }, [tabIndex, value]);
  return /*#__PURE__*/React.createElement(FlatButton, {
    value: value,
    className: cn(className, classes.root, 'p-0', 'tab-item', {
      'text-blue': isActive
    }),
    onClick: onTabClick,
    disabled: disabled,
    "data-qa": "tab"
  }, title);
};

Tab.defaultProps = {
  children: null,
  disabled: false,
  value: undefined
};
Tab.propTypes = {
  /** The tab title */
  title: PropTypes.node.isRequired,

  /** Set tab content to show when active */
  children: PropTypes.node,

  /** Indicator whether or not the tab is disabled */
  disabled: PropTypes.bool,

  /** The tab value to be passed when clicked */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.shape()])
};
export default Tab;